import { type FC, type PropsWithChildren, useEffect } from 'react';
import { useUnit } from 'effector-react';
import { useLocation } from 'react-router';
import { $mode, setMode } from '~/shared/store/mode';
import { PayinTicketsWatcher, PayoutTicketsWatcher } from './components';
import { getModeByPathname } from './lib';

export const WatchersProvider: FC<PropsWithChildren> = ({ children }) => {
    const { pathname } = useLocation();
    const { mode, updateMode } = useUnit({ mode: $mode, updateMode: setMode });
    const routeMode = getModeByPathname(pathname);
    const activeMode = routeMode ?? mode;

    useEffect(() => {
        if (routeMode && routeMode !== mode) {
            updateMode(routeMode);
        }
    }, [mode, routeMode, updateMode]);

    return (
        <>
            {activeMode === 'payin' ? <PayinTicketsWatcher /> : <PayoutTicketsWatcher />}
            {children}
        </>
    );
};
